/**
 * Filters promo banners based on their isSMB property and the current route
 *
 * @param {Array} promoBanners - Array of promo banner objects from menuData
 * @param {string} currentPath - The current route path
 * @returns {Array} - Filtered array of promo banners
 */
export const filterPromoBanners = (promoBanners, currentPath) => {
    if (
        !promoBanners ||
        !Array.isArray(promoBanners) ||
        promoBanners.length === 0
    ) {
        return []
    }

    // Check if current path is a business route
    const isBusinessRoute =
        currentPath === '/gift-cards-for-business/merchants/' ||
        currentPath.startsWith('/gift-cards-for-business/')

    // If on a business route, only show SMB banners
    // Otherwise, filter out SMB banners
    return promoBanners.filter((banner) =>
        isBusinessRoute ? banner.isSMB === true : banner.isSMB !== true
    )
}
